import { ThemeColors } from "./theme.base";

export const prodColors = {
  light: {
    primary: { main: "#D35400", light: "#E67E22", dark: "#A84300" },
    secondary: { main: "#26C6DA" },
    background: {
      default: "#fafafa",
      paper: "#ffffff",
      custom: "#f5f5f5",
      body: "#fafafa",
    },
    text: { primary: "#222222", secondary: "#555555" },
    link: "#1976d2",
    highlightedRow: "#f0f8ff",
    borders: { appBar: "1px solid rgba(0,0,0,0.12)" },
    dataGrid: { header: "#f5f5f5" },
  },

  dark: {
    primary: { main: "#FF6F00", light: "#FFA040", dark: "#C43E00" },
    secondary: { main: "#00BFA5" },
    background: {
      default: "#0f0f0f",
      paper: "#0f0f0f",
      custom: "#121212",
      body: "#0a0a0a",
    },
    text: { primary: "#ffffff", secondary: "#aaaaaa" },
    link: "#4ea8ff",
    highlightedRow: "#1a1a1a",
    borders: { appBar: "1px solid #222222" },
    dataGrid: { header: "#1a1a1a" },
  },
} satisfies Record<"light" | "dark", ThemeColors>;
